<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-08-09 11:25:39
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-08-18 17:11:48
-->
<template>
	<div class="ml-40 select fz-14 ">
		<el-select v-model="value" @change="change($event)" style="width:140px">
			<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
		</el-select>
	</div>
</template>

<script>
export default {
	name: 'TimeSelect',
	data() {
		return {
			value: '付款时间',
			options: [
				{ value: '1', label: '付款时间' },
				{ value: '2', label: '结算时间' },
			],
		};
	},
	methods: {
		change(val) {
			this.$emit('changeSelect', val);
		},
	},
};
</script>
<style lang="less" scoped>
.select {
	margin-right: -1px;
}
</style>
